<template>
    <div class="relation-bar-wrapper">
        <div class="opeat-r opeate-content">
            <LangSelect :disabled="disabled" :value="initLang" class="lang-select" @change="langChange" :requireAll="true" />
                <Search ref="searchInput" :hasInput="true" :placeholder="placeholder" class="question-search" @searchChange="searchChange" @inputChange="searchChange">
                <Select
                    :initValue="QuestionType"
                    :options="questionOptions"
                    class="question-select"
                    slot="right"
                    @menuClick="questionTypeChange"
                    :topOrBottom="40"
                />
            </Search>
            <Select
                v-if="applySkinType !== 'questionSelectorTableModal'"
                :initValue="initStatus"
                :options="statusOptions"
                class="status-select"
                @menuClick="statusChange"
            />
        </div>
    </div>
</template>

<script>
import Search from "@/views/zhiji/bComponents/inputs/Search";
import Select from "@/views/zhiji/bComponents/inputs/Select";
import LangSelect from "@/components/langSelect";
import { statusOptions, questionOptions } from "@/views/zhiji/pages/knowlege/pageConfig.js";
import { debounce } from "@/views/zhiji/js/common/util.js";

export default {
    name: "RelationQuesBar",
    props: ["data", "row", "applySkinType", "currentLang", "searchReset", "disabled"],
    components: {
        Search,
        Select,
        LangSelect
    },
    data() {
        return {
            QuestionType: "stand",
            pageOne: 1,
            initStatus: "all",
        };
    },
    mounted() {
        if (this.searchReset) {
            this.$refs.searchInput.searchInfo = this.searchReset.questionId;
            this.QuestionType = this.searchReset.questionType;
        }
        if (this.data && this.data.requestObj && this.data.requestObj.field) {
            this.$refs.searchInput.searchInfo = this.data.requestObj.field;
            this.initStatus = this.data.requestObj.status || "all";
            this.QuestionType = this.data.requestObj.type;
        }
        this.searchHanlder = debounce(data => {
            let searchField = data[0];
            this.searchQuestion(searchField);
        }, 500);
    },
    computed: {
        sceneId() {
            return this.getStorePorp("querySetting").classId;
        },
        statusOptions() {
            return statusOptions();
        },
        questionOptions() {
            return questionOptions();
        },
        placeholder() {
            return this.$t("zhiji.common.inputHolderLabel");
        },
        querySetting() {
            return this.getStorePorp("querySetting");
        },
        initLang() {
            return this.currentLang || "all";
        }
    },
    watch: {
        // 监控中英文切换，重新从后台取对应语言数据
        placeholder() {
            this.$store.commit("zhiji/clearCreatorOption");
            this.$emit("getBatchQuestionList", { page: this.pageOne });
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        statusChange(data) {
            this.$emit("getBatchQuestionList", {
                status: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        questionTypeChange(data) {
            this.QuestionType = data.value;
        },
        searchChange(data) {
            this.searchHanlder(data);
            this.$emit("change", data.value);
        },
        searchQuestion(data) {
            let searchType = this.QuestionType;
            data.value === "" ? (searchType = "") : "";
            this.$emit("assignmentValue", data.value);
            this.$emit("getBatchQuestionList", {
                type: searchType,
                field: data.value,
                page: this.pageOne
            });
            this.$emit("initCurrPage");
        },
        langChange(data) {
            this.$emit("langChange", data);
            this.$emit("getBatchQuestionList", {
                lang: data,
                page: this.pageOne
            });
        }
    }
};
</script>

<style lang="less" scoped>
.relation-bar-wrapper {
    .select-opt,
    .opeat-r {
        display: inline-block;
    }

    .opeat-r {
        font-size: 0;
        float: left;
        margin-bottom: 8px;
    }

    .status-select,
    .question-search {
        width: 120px;
        margin-bottom: 8px;
        margin-left: 10px;
        display: inline-block;
        vertical-align: middle;
    }
    .question-search {
        display: inline-flex;
    }
    .question-search {
        font-size: 12px;
        width: 318px;
    }
    .question-select {
        border: 0;
        border-right: 1px solid #e3e3e3;
        border-radius: 0;
    }
    .primary-btn.btn-export {
        position: absolute;
        top: 18px;
        right: 0;
        border: 1px solid#2EC2FF !important;
        color: #2ec2ff !important;
        background: #fff !important;
        box-shadow: none;
        /deep/.round-btn-icon {
            width: 16px;
            vertical-align: -1px;
        }
    }
}
</style>
